import React from 'react';
import { motion } from 'framer-motion';
import { CheckCheck, Instagram } from 'lucide-react';
const whatsappTestimonials = [{
  name: "María G.",
  initials: "MG",
  status: "en línea",
  time: "10:42 a.m.",
  text: "Abu!! ✨ Pensé que era otro libro de autoayuda, pero los Sonidos Mágicos cambiaron mi energía desde la primera semana. Por fin entiendo lo que significa merecer. Gracias infinitas 🙏"
}, {
  name: "Valentina P.",
  initials: "VP",
  status: "en línea",
  time: "4:15 p.m.",
  text: "Los Números Mágicos me parecieron raros al principio, pero cuando empecé a aplicarlos, algo en mi vibración cambió. No sé cómo explicarlo, pero funciona. Ya cerré mi primer cliente grande!! 😭💖"
}];
export function Testimonials() {
  return <section className="py-20 bg-secondary" data-id="element-228" data-mp="v9g9bl2obyo3">
      <div className="max-w-[1100px] mx-auto px-5" data-id="element-229" data-mp="v859fwccnb29">
        <div className="text-center mb-12" data-id="element-230" data-mp="qac1oyvee8zv">
          <span className="inline-block text-xs font-semibold tracking-[0.15em] uppercase text-violet-light mb-4" data-id="element-231" data-mp="qbn7f48elqtm">
            Resultados Reales
          </span>
          <h2 className="font-display text-3xl md:text-[42px] font-bold leading-[1.2] text-white" data-id="element-232" data-mp="m4roidrgpg6y">
            Mensajes que me llenan el <span className="text-gold" data-id="element-233" data-mp="78tvv5gqytzh">corazón</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[900px] mx-auto" data-id="element-234" data-mp="c6buo311vstr">
          
          {/* WhatsApp Cards */}
          {whatsappTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-[#0d1117] rounded-2xl overflow-hidden border border-white/5 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.4)] transition-all" data-id="element-235" data-mp="14vj0ln2u3kp1" data-mpi={i}>
              <div className="bg-[#1f2937] px-4 py-2.5 flex items-center gap-2.5 border-b border-white/5" data-id="element-236" data-mp="1nmk0cdbs3k9n">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-violet-dark to-violet flex items-center justify-center text-[13px] font-bold text-white shrink-0" data-id="element-237" data-mp="1xiipsomnt6f0">
                  {t.initials}
                </div>
                <div data-id="element-238" data-mp="1ofzv4rt1203u">
                  <div className="text-[13px] font-semibold text-white" data-id="element-239" data-mp="1ojfa7umpb959">{t.name}</div>
                  <div className="text-[11px] text-[#25D366]" data-id="element-240" data-mp="1jhpzkg3e4xhp">escribiendo...</div>
                </div>
              </div>
              <div className="p-4" data-id="element-241" data-mp="1ekzhxobxttu6">
                <div className="bg-[#1e293b] rounded-lg rounded-tl-none p-3 relative max-w-[90%]" data-id="element-242" data-mp="19s6cey8nahh1">
                  <div className="absolute top-0 -left-1.5 border-t-0 border-r-[6px] border-b-[6px] border-l-0 border-solid border-transparent border-r-[#1e293b]" data-id="element-243" data-mp="14sjzkpwqb38r" />
                  <p className="text-sm text-white leading-[1.6]" data-id="element-244" data-mp="10px32bp44u58">
                    {t.text}
                  </p>
                  <div className="flex items-center justify-end gap-1 mt-1.5" data-id="element-245" data-mp="qtu4fftgzdn1">
                    <span className="text-[10px] text-gray-500" data-id="element-246" data-mp="qvwrps38mso2">{t.time}</span>
                    <CheckCheck className="w-3.5 h-3.5 text-blue-400" data-id="element-247" data-mp="32gnv4yhbtr6i" />
                  </div>
                </div>
                <div className="flex gap-0.5 mt-3 pl-1" data-id="element-248" data-mp="37htp0zmq3khm">
                  {[...Array(5)].map((_, j) => <span key={j} className="text-gold text-[13px]" data-id="element-249" data-mp="3ggos42uh0egp" data-mpi={j}>★</span>)}
                </div>
              </div>
            </motion.div>)}

          {/* Instagram Card */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-[#0d1117] rounded-2xl overflow-hidden border border-white/5 md:col-span-2 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.4)] transition-all" data-id="element-250" data-mp="2op9a6m3uzfwt">
            <div className="bg-gradient-to-r from-[#1a0533] to-[#0d1117] px-5 py-3.5 flex items-center justify-between border-b border-white/5" data-id="element-251" data-mp="20y3se1ecydjv">
              <div className="flex items-center gap-3" data-id="element-252" data-mp="1lxydd5srthka">
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#833ab4] via-[#fd1d1d] to-[#fcb045] flex items-center justify-center text-sm font-bold text-white" data-id="element-253" data-mp="1gxtuxa8aycrf">
                  RL
                </div>
                <div data-id="element-254" data-mp="1qvgcy5kwekfm">
                  <div className="text-sm font-semibold text-white" data-id="element-255" data-mp="1quyh3a25e888">Roxana L.</div>
                  <div className="text-xs text-gray-500" data-id="element-256" data-mp="24mlghirdzwv8">@roxana_manifesta</div>
                </div>
              </div>
              <Instagram className="w-5 h-5 text-[#E1306C]" data-id="element-257" data-mp="1zni9hsrujgkm" />
            </div>
            <div className="p-5" data-id="element-258" data-mp="2elu7c2qygvdd">
              <p className="text-[15px] text-gray-400 leading-[1.8]" data-id="element-259" data-mp="2el2c4t19sznm">
                El Diario de Manifestación me dio la estructura que siempre necesité. Ahora no solo 'visualizo', sino que actúo alineada. <span className="text-gold font-semibold" data-id="element-260" data-mp="k830fb00gplm">En 3 semanas conseguí el aumento que llevaba pidiendo 2 años.</span> Gracias Abu por crear algo tan real y aplicable. ✨🙌
              </p>
            </div>
            <div className="px-5 py-3 border-t border-white/5 flex items-center gap-4" data-id="element-261" data-mp="2qwlg4flu6mla">
              <div className="text-xs text-gray-500 flex items-center gap-1" data-id="element-262" data-mp="2vud9zf61kis4">
                ❤️ 124 Me gusta
              </div>
              <div className="text-xs text-gray-500" data-id="element-263" data-mp="2h45xrh6mnvzv">
                Hace 2 días
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </section>;
}